import { BiTableDensity, BiVizStyle, BiVizType } from '@euler/model/bi/viz';
import {
  BiGalleryCategory,
  BiGalleryCategoryKey,
  BiGalleryDashboardCard,
} from '../functions/biGalleryTypes';
import {
  cents,
  kGalleryFields as f,
  galleryReady,
  galleryResult,
  kGalleryMonths,
} from './biGalleryFields';

const rows: [string, string, number, number, number, number][] = [
  ['常规保养', '全合成机油更换', 148, 96800, 0.52, 42],
  ['常规保养', '空调滤芯更换', 77, 12300, 0.31, 18],
  ['钣金喷漆', '前保险杠喷漆', 41, 61500, 0.12, 380],
  ['钣金喷漆', '车门凹陷修复', 23, 27600, 0.09, 240],
  ['轮胎更换', '米其林轮胎（单条）', 96, 88400, 0.27, 35],
  ['轮胎更换', '四轮定位', 83, 24900, 0.44, 50],
  ['美容洗护', '精致洗车', 212, 12720, 0.68, 30],
  ['电瓶更换', '瓦尔塔电瓶', 19, 15200, 0.05, 25],
];

const result = galleryResult(
  [f.serviceType, f.item, f.orders, f.revenue, f.returnRate, f.jobTime],
  rows.map(([type, item, orders, yuan, rate, minutes]) => [
    type,
    item,
    orders,
    cents(yuan),
    rate,
    minutes,
  ]),
);

function itemsTable(style?: BiVizStyle): BiGalleryDashboardCard {
  return {
    surface: 'dashboard',
    title: '本月服务项目明细',
    viz: {
      type: BiVizType.Table,
      columns: [
        { key: f.serviceType.key },
        { key: f.item.key },
        { key: f.orders.key },
        { key: f.revenue.key },
        { key: f.returnRate.key },
        { key: f.jobTime.key },
      ],
      ...(style ? { style } : {}),
    },
    data: galleryReady(result),
    rows: 6,
  };
}

const kTypes = ['常规保养', '钣金喷漆', '轮胎更换', '美容洗护', '电瓶更换'];
const kWideMonths = kGalleryMonths.slice(4);

const wideResult = galleryResult(
  [f.month, f.serviceType, f.revenue],
  kWideMonths.flatMap((month, i) =>
    kTypes.map((type, j) => [month, type, cents(20000 + i * 3100 + j * 9700)]),
  ),
);

const plain = itemsTable();

export const kTableCategory: BiGalleryCategory = {
  key: BiGalleryCategoryKey.Table,
  name: '表格',
  description: '维度 + 指标、紧凑 / 常规、斑马纹、合计行、多系列宽表',
  preview: plain,
  variants: [
    {
      key: 'plain',
      name: '维度 + 指标',
      note: '两个维度、四种格式的指标',
      card: plain,
    },
    {
      key: 'compact',
      name: '紧凑',
      note: 'table.density = compact',
      card: itemsTable({
        table: {
          density: BiTableDensity.Compact,
          zebra: false,
          totalsRow: false,
        },
      }),
    },
    {
      key: 'normal',
      name: '常规',
      note: 'table.density = normal',
      card: itemsTable({
        table: {
          density: BiTableDensity.Normal,
          zebra: false,
          totalsRow: false,
        },
      }),
    },
    {
      key: 'zebra',
      name: '斑马纹',
      note: 'table.zebra = true',
      card: itemsTable({
        table: {
          density: BiTableDensity.Normal,
          zebra: true,
          totalsRow: false,
        },
      }),
    },
    {
      key: 'totals',
      name: '合计行',
      note: 'table.totalsRow = true',
      card: itemsTable({
        table: { density: BiTableDensity.Normal, zebra: true, totalsRow: true },
      }),
    },
    {
      key: 'wide',
      name: '多系列宽表',
      note: '按服务类型拆分的折线；切换为数据表，每个系列一列',
      card: {
        surface: 'dashboard',
        title: '各服务类型月度营收',
        viz: {
          type: BiVizType.Line,
          x: f.month.key,
          series: [{ key: f.revenue.key }],
          seriesBy: f.serviceType.key,
          style: {
            table: {
              density: BiTableDensity.Compact,
              zebra: true,
              totalsRow: true,
            },
          },
        },
        data: galleryReady(wideResult),
        rows: 5,
      },
    },
  ],
};
